import hasUserRole from './hasUserRole'
import type { UserLike } from './types'

export default function canUsersChat(user1: UserLike, user2: UserLike): boolean {
  return hasUserRole(user1, 'user:tutor') || hasUserRole(user2, 'user:tutor')
}
